import React, { useEffect, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import FormRenderer, { ComponentMapper, FormTemplate, componentTypes } from "../../../common/FormRenderer";
import { Button } from "react-bootstrap";
import { getValue } from "../../../../utils/common";
import { GetActionTitle } from "../Master.constants";

function CityDetails(this: any, { action, record : data, onClose }: any) {
    const [city, setCity] = useState<any>({ hideButtons: true });
    
    const schema = {
        fields: [
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'name',
                label: 'City Name',
                content: getValue(city, 'name')
            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'code',
                label: 'City Code',
                styleClass: 'text-uppercase',
                content: getValue(city, 'code')

            },
            {
                component: componentTypes.PLAIN_TEXT,
                name: 'state',
                label: 'State',
                content: getValue(city, 'state.label')
            },
        ],
    };

    useEffect(() => {
        if (data) {
            setCity({ ...city, ...data, state: { value: data.state.id, label: data.state.name } });
        }
    }, [data]);

    return (
        <Modal show={true} backdrop="static" dialogClassName="drawer" animation={false}>
            <Modal.Header closeButton={true} onHide={onClose}>
                <Modal.Title className="bg">{GetActionTitle('City', action)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormRenderer FormTemplate={FormTemplate}
                    initialValues={city}
                    componentMapper={ComponentMapper}
                    schema={schema}
                />
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                {
                    <Button variant="primary" onClick={onClose} className="px-4 ms-auto">{'Close'}</Button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default CityDetails;
